import { useEffect, useState } from "react"

const STORAGE_KEY = "chat-panel-width"

const useChatPanelResize = (initialWidth = 80) => {
  const [chatWidth, setChatWidth] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY)
    return saved ? parseFloat(saved) : initialWidth
  })
  const [isResizingChat, setIsResizingChat] = useState(false)

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, chatWidth)
  }, [chatWidth])

  useEffect(() => {
    if (!isResizingChat) return
    const onMove = (e) => {
      const w = ((window.innerWidth - e.clientX) / window.innerWidth) * 100
      if (w >= 40 && w <= 95) setChatWidth(w)
    }
    const onUp = () => setIsResizingChat(false)
    document.addEventListener("mousemove", onMove)
    document.addEventListener("mouseup", onUp)
    return () => {
      document.removeEventListener("mousemove", onMove)
      document.removeEventListener("mouseup", onUp)
    }
  }, [isResizingChat])

  return { chatWidth, isResizingChat, startResizeChat: () => setIsResizingChat(true) }
}

export default useChatPanelResize
